import { z } from 'zod';
import { format } from 'date-fns';

// Zod schema using built-in ISO date validation (YYYY-MM-DD)
export const ISODateString = z.iso.date().meta({
  description: 'ISO 8601 date string (YYYY-MM-DD)',
  example: '2025-01-15'
});
export type ISODateString = z.infer<typeof ISODateString>;

// Transformer that accepts Date objects or strings from the database and converts to ISODateString
export const ISODateStringFromDB = z
  .union([z.string(), z.date()])
  .transform(date => {
    if (typeof date === 'string') {
      // Handle ISO timestamp strings (e.g., "2026-01-31T00:00:00.000Z") by extracting just the date part
      return date.length > 10 ? date.substring(0, 10) : date;
    }
    return format(date, 'yyyy-MM-dd');
  })
  .pipe(ISODateString);

// Date range
export const ISODateRange = z
  .object({
    from: ISODateString.meta({ description: 'Range start date (inclusive)' }),
    to: ISODateString.meta({ description: 'Range end date (inclusive)' })
  })
  .meta({ description: 'Date range with from and to dates' });
export type ISODateRange = z.infer<typeof ISODateRange>;

// Date range transformer from DB (handles both Date objects and ISO timestamp strings)
export const ISODateRangeFromDB = z.object({
  from: ISODateStringFromDB,
  to: ISODateStringFromDB
});
export type ISODateRangeFromDB = z.infer<typeof ISODateRangeFromDB>;

// Pacing block for line items (defined here to avoid circular dependencies)
export const PacingBlockV2FromDB = z.object({
  dates: ISODateRangeFromDB,
  budget: z.number('Price is required')
});
export type PacingBlockV2FromDB = z.infer<typeof PacingBlockV2FromDB>;
